import baseApi from 'services/api/base';
import getProductKey from 'helper/requests/getProductKey';
import { GetChartsParams, Charts } from 'types/Meteorology/Agro/CultureIndex/Location/getCharts';
import { transformGetCharts } from 'helper/Meteorology/Agro/CultureIndex/Location';

export const cultureIndexLocationApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getCultureIndexLocationCharts: build.query<Charts[], GetChartsParams>({
      /* eslint-disable @typescript-eslint/no-unused-vars */
      query: ({
        culture, forecastDate, periodStart, periodEnd, stage, location,
      }) => {
        const productKey = getProductKey('agro');
        return {
          url: `produtos/indice-desenvolvimento-cultura/calcular?product_key=${productKey}`,
          method: 'POST',
          body: {
            cultura: culture,
            data_rodada: forecastDate,
            data_inicial: periodStart,
            data_final: periodEnd,
            fase_fenologica: stage,
            local: location,
          },
        };
      },
      transformResponse: transformGetCharts,
    }),
  }),
});

export const {
  useGetCultureIndexLocationChartsQuery,
  useLazyGetCultureIndexLocationChartsQuery,
} = cultureIndexLocationApi;
